import { createContext, ReactNode, useContext, useLayoutEffect, useState } from "react";

const storageKey = "darkTheme";

const PortfolioThemeContext = createContext({ dark: false, toggle: () => {} });

const preferredTheme = () => {
  const saved = window.localStorage.getItem(storageKey);
  if (saved !== null) return saved === "true";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
};

export const PortfolioThemeProvider = ({ children }: { children: ReactNode }) => {
  const [dark, setDark] = useState(preferredTheme);

  useLayoutEffect(() => {
    document.documentElement.dataset.portfolioTheme = dark ? "dark" : "light";
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#181a18" : "#f3f0e8");
  }, [dark]);

  const toggle = () => setDark((current) => {
    window.localStorage.setItem(storageKey, String(!current));
    return !current;
  });

  return <PortfolioThemeContext.Provider value={{ dark, toggle }}>{children}</PortfolioThemeContext.Provider>;
};

export const usePortfolioTheme = () => useContext(PortfolioThemeContext);
